const AffiliateUpdateStyles = theme => ({
    fieldWrapper: {
        paddingTop: 20
    },
    updateButton: {
        marginLeft: 24,
        color: '#fff'
    },
    cancelButton: {
        marginLeft: 16,
        backgroundColor: '#fff',
    }
});

export default AffiliateUpdateStyles;